import React from "react";
import { Box, Typography } from "@mui/material";

function ColorInfo({ answered, marked, notAnswered, visitedQuestions, notVisited }) {
  const items = [
    { color: "#1976d2", label: "Attempted", count: answered },
    { color: "#9c27b0", label: "Review", count: marked },
    { color: "#fff", border: "1.5px solid #aaa", label: "Not Attempted", count: notVisited },
    { color: "#d1d1d1", label: "Skipped", count: Number(notAnswered) },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px 12px",
        padding: "8px 10px",
        borderTop: "1px solid #e0e0e0",
        background: "#f8f9fa",
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "3px",
              background: item.color,
              border: item.border || "none",
              flexShrink: 0,
            }}
          />
          <Typography sx={{ fontSize: "0.72rem", color: "#555" }}>
            {item.label} ({item.count})
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default ColorInfo;
